export default __webpack_public_path__ + "static/media/flag_fr.589da1a2.svg";